
import { companyIdentifierTypes, CompanyModel } from 'api';
import { TilesList, TopSection } from 'lqx-react';
import * as React from 'react';
import { AddIdentifier, IdentifiersRow, removeIdentifier } from '../../../../common/identifers';

export const EditIdentifiers = ({ company }: { company: CompanyModel }) => {
    return (
        <TopSection title="Identifiers">
            <TilesList
                items = { company.identifiers.models }
                itemSize={66}
                height={400}
                renderer={IdentifiersRow(false, removeIdentifier(company.identifiers))}
            />
            <AddIdentifier identifiers={company.identifiers} identifierTypes = {companyIdentifierTypes}/>
        </TopSection>
    );
};
